import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { MessageService } from 'src/app/modules/shared/services/message.service';
@Component({
  selector: 'app-create-coupon',
  templateUrl: './create-coupon.component.html',
  styleUrls: ['./create-coupon.component.scss']
})
export class CreateCouponComponent implements OnInit {

  public loginData: any;

  public couponCreationStep: number;

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _messageService: MessageService
  ) { }

  async ngOnInit() {
    this.loginData = await this._utilService.getStorageData('C_LOGIN');

    this.couponCreationStep = 1; // Set to step 1
    let responseRemoveStorageDataC_NEW_COUPON = await this._utilService.removeStorageData('C_NEW_COUPON'); // Remove storage if exists
  }

  // On step selection
  async onStepSelection(event: any) {
    //console.log(event);
  }

  // On navigation click
  async onNavigationClick(event: any) {
    this._messageService.sendMessage({id: 'message-updatePreview', step: event.step});

    switch(event.step) {
      case 1: { // Step 1
        if (event.button == 'next') {
          this.couponCreationStep = 2;
        }
        break;
      } case 2: { // Step 2
        if (event.button == 'next') {
          this.couponCreationStep = 3;
        } else {
          this.couponCreationStep = 1;
        }
        break;
      } case 3: { // Step 3
        if (event.button == 'next') {
          this.couponCreationStep = 4;
        } else {
          this.couponCreationStep = 2;
        }
        break;
      } case 4: { // Step 4
        if (event.button == 'previous') {
          this.couponCreationStep = 3;
        } else if (event.button == 'submit') {
          this._utilService.showToast('Coupon created successfully', '', 'success', {});
          this._router.navigate(['/cpg/coupon-list']); // Go to coupon list
        }
        break;
      }
    }
  }

}
